module.exports = __webpack_public_path__ + "static/media/emptycart.29b27a58.gif";